import React, { useState, useEffect } from "react";
import "./CourseScreen.css";

function CourseScreen() {
  const [isPayPalVisible, setIsPayPalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const course = {
    title: "AI-Powered Research Workshop",
    description:
      "Learn how to use AI to accelerate your research and boost productivity.",
    price: 99.99,
    image:
      "https://foundr.com/wp-content/uploads/2023/04/How-to-create-an-online-course.jpg.webp",
  };

  useEffect(() => {
    if (isPayPalVisible) {
      const scriptId = "paypal-js-sdk";
      if (!document.getElementById(scriptId)) {
        console.log("Loading PayPal script...");
        const script = document.createElement("script");
        script.id = scriptId;
        script.src =
          "https://www.paypal.com/sdk/js?client-id=BAAYWXYvMr4CcyPUugFMlYcVLnq3IJBmWAmkw2ExaA4hGWM83mOa4sfikVNFUT8HkyjKKC22ihzRZoLWSw&components=hosted-buttons&disable-funding=venmo&currency=USD";
        script.onload = () => {
          console.log("PayPal script loaded successfully.");
          if (window.paypal && window.paypal.HostedButtons) {
            window.paypal
              .HostedButtons({
                hostedButtonId: "MMLE9USNEYTYG",
              })
              .render("#paypal-container-MMLE9USNEYTYG")
              .catch((err) =>
                console.error("PayPal Hosted Buttons render error:", err)
              );
          } else {
            console.error("PayPal Hosted Buttons not available.");
          }
        };
        script.onerror = () => {
          console.error("Failed to load PayPal script.");
        };
        document.body.appendChild(script);
      } else if (window.paypal && window.paypal.HostedButtons) {
        console.log("PayPal script already loaded.");
        window.paypal
          .HostedButtons({
            hostedButtonId: "MMLE9USNEYTYG",
          })
          .render("#paypal-container-MMLE9USNEYTYG")
          .catch((err) =>
            console.error("PayPal Hosted Buttons render error:", err)
          );
      } else {
        console.error("PayPal Hosted Buttons not available.");
      }
    }
  }, [isPayPalVisible]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);
    return () => clearTimeout(timer);
  }, []);
  const handlePayment = () => {
    setIsPayPalVisible(true);
  };
  if (isLoading) {
    return (
      <>
        <div className="loader-screen">
          <p>Loading your personalized course...</p>
          <div className="loader"></div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="course-screen">
        <h1>Your Recommended Courses</h1>
        <div className="course-details">
          <h2>{course.title}</h2>
          <p>{course.description}</p>
          <p>
            <strong>Price:</strong> ${course.price.toFixed(2)}
          </p>
        </div>
        <div>
          {isPayPalVisible ? (
            <div id="paypal-container-MMLE9USNEYTYG"></div> 
          ) : (
            <button onClick={handlePayment}>Proceed to Payment</button>
          )}
        </div>
      </div>
    </>
  );
}
export default CourseScreen;
